import angular from 'angular'

// component
import titleBarTabNav from './component/titleBarTabNav.js'

export default angular
  .module('portalApp.titleBarTabNav', [])
  .component('titleBarTabNav', titleBarTabNav).name
